import React from 'react';
interface Props {
  className?: string;
  animate?: boolean;
  children?: React.ReactNode;
}
export const Skeleton: React.FC<Props> = ({
  className = '',
  animate = true,
  children
}) => {
  return <div className={`bg-surface-light border border-surface-border/50 
                 ${animate ? 'animate-pulse' : ''} ${className}`} role="presentation" aria-hidden="true" data-id="element-437">
      {children}
    </div>;
};
export const KnowledgeSpaceCardSkeleton = () => {
  return <div className="bg-surface-light border border-surface-border p-6 rounded-none" data-id="element-438">
      <div className="flex items-center justify-between mb-6" data-id="element-439">
        <Skeleton className="h-6 w-48 rounded-none" data-id="element-440" />
        <Skeleton className="h-5 w-5 rounded-none" data-id="element-441" />
      </div>
      <div className="space-y-6" data-id="element-442">
        <div className="flex items-center gap-4" data-id="element-443">
          <Skeleton className="p-3 rounded-none h-12 w-12" data-id="element-444" />
          <div className="space-y-2" data-id="element-445">
            <Skeleton className="h-7 w-16 rounded-none" data-id="element-446" />
            <Skeleton className="h-4 w-24 rounded-none" data-id="element-447" />
          </div>
        </div>
        <div className="flex items-center justify-between gap-4 pt-6 border-t border-surface-border" data-id="element-448">
          <Skeleton className="h-4 w-32 rounded-none" data-id="element-449" />
          <Skeleton className="h-4 w-24 rounded-none" data-id="element-450" />
        </div>
      </div>
    </div>;
};